import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import jwt from "jwt-decode";
import api from "../../api/api";

export const admin_login = createAsyncThunk(
  "auth/admin_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/admin-login", info, {
        withCredentials: true,
      });
      localStorage.setItem("accessToken", data.token);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const seller_login = createAsyncThunk(
  "auth/seller_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/seller-login", info, {
        withCredentials: true,
      });
      localStorage.setItem("accessToken", data.token);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const employee_login = createAsyncThunk(
  "auth/employee_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/employee-login", info, {
        withCredentials: true,
      });
      localStorage.setItem("accessToken", data.token);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async ({ navigate, role }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/logout", { withCredentials: true });
      localStorage.removeItem("accessToken");
      
      // Clear session timer
      if (typeof window !== 'undefined' && window.clearSessionTimer) {
        window.clearSessionTimer();
      }
      
      if (role === "admin") {
        navigate("/admin/login");
      } else {
        navigate("/login");
      }

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const seller_register = createAsyncThunk(
  "auth/seller_register",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      // console.log(info);
      const { data } = await api.post("/seller-register", info, {
        withCredentials: true,
      });
      localStorage.setItem("accessToken", data.token);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const profile_image_upload = createAsyncThunk(
  "auth/profile_image_upload",
  async (image, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/profile-image-upload", image, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const profile_info_add = createAsyncThunk(
  "auth/profile_info_add",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/profile-info-add", info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const update_currency = createAsyncThunk(
  "auth/update_currency",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/update-country-currency", info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_user_info = createAsyncThunk(
  "auth/get_user_info",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-user", { withCredentials: true });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllCountries = createAsyncThunk(
  "auth/getAllCountries",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/countries", { withCredentials: true });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllCurrencies = createAsyncThunk(
  "auth/getAllCurrencies",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/currencies", { withCredentials: true });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_support_info = createAsyncThunk(
  "auth/get_support_info",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-support-info", {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const update_support_info = createAsyncThunk(
  "auth/update_support_info",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/update-support-info", info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const support_logo_upload = createAsyncThunk(
  "auth/support_logo_upload",
  async (logo, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/support-logo-upload", logo, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (passwordData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/change-password", passwordData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateVoucherNumber = createAsyncThunk(
  "auth/updateVoucherNumber",
  async (voucherData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/update-voucher-number", voucherData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updatePosConfig = createAsyncThunk(
  "auth/updatePosConfig",
  async (posConfigData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/update-pos-config", posConfigData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStockVisibility = createAsyncThunk(
  "auth/updateStockVisibility",
  async (showStockQuantity, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put("/update-stock-visibility", { showStockQuantity }, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const returnRole = (token) => {
  if (!token) return "";
  
  try {
    const decodeToken = jwt(token);
    const expireTime = new Date(decodeToken.exp * 1000);
    
    if (new Date() > expireTime) {
      localStorage.removeItem("accessToken");
      return "";
    }
    
    return decodeToken.role;
  } catch (error) {
    localStorage.removeItem("accessToken");
    return "";
  }
};

export const authReducer = createSlice({
  name: "auth",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    userInfo: "",
    role: returnRole(localStorage.getItem("accessToken")),
    token: localStorage.getItem("accessToken"),
    countries: [],
    currencies: [],
    supportInfo: "",
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
    clearAuth: (state) => {
      state.token = null;
      state.role = "";
      state.userInfo = "";
      localStorage.removeItem("accessToken");
      
      // Clear session timer
      if (typeof window !== 'undefined' && window.clearSessionTimer) {
        window.clearSessionTimer();
      }
    }
  },
  extraReducers: {
    [admin_login.pending]: (state, _) => {
      state.loader = true;
    },
    [admin_login.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [admin_login.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.token = payload.token;
      state.role = returnRole(payload.token);
      state.userInfo = payload.userInfo;
    },
    [seller_login.pending]: (state, _) => {
      state.loader = true;
    },
    [seller_login.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Login failed. Please try again.';
    },
    [seller_login.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.token = payload.token;
      state.role = returnRole(payload.token);
      state.userInfo = payload.userInfo;
    },
    [employee_login.pending]: (state, _) => {
      state.loader = true;
    },
    [employee_login.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Login failed. Please try again.';
    },
    [employee_login.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.token = payload.token;
      state.role = returnRole(payload.token);
      state.userInfo = payload.userInfo;
    },
    [seller_register.pending]: (state, _) => {
      state.loader = true;
    },
    [seller_register.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [seller_register.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.token = payload.token;
      state.role = returnRole(payload.token);
      state.userInfo = payload.userInfo;
    },
    [get_user_info.fulfilled]: (state, { payload }) => {
      state.loader = false;
      if (payload && payload.userInfo) {
        state.userInfo = payload.userInfo;
        state.role = payload.userInfo.role || '';
      } else {
        state.userInfo = '';
        state.role = '';
      }
    },
    [get_user_info.rejected]: (state, { payload }) => {
      state.loader = false;
      // Clear auth state when get_user_info fails (invalid token)
      state.token = null;
      state.role = "";
      state.userInfo = "";
      state.errorMessage = payload?.error || 'Authentication failed. Please login again.';
      localStorage.removeItem("accessToken");
    },
    [profile_image_upload.pending]: (state, _) => {
      state.loader = true;
    },
    [profile_image_upload.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Image upload failed';
    },
    [profile_image_upload.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.userInfo = payload.userInfo;
      state.successMessage = payload.message;
    },
    [profile_info_add.pending]: (state, _) => {
      state.loader = true;
    },
    [profile_info_add.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.userInfo = payload.userInfo;
      state.successMessage = payload.message;
    },
    [getAllCountries.pending]: (state, _) => {
      state.loader = true;
    },
    [getAllCountries.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.countries = payload.countries;
    },
    [getAllCountries.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [getAllCurrencies.pending]: (state, _) => {
      state.loader = true;
    },
    [getAllCurrencies.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.currencies = payload.currencies;
    },
    [getAllCurrencies.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [update_currency.fulfilled]: (state, { payload }) => {
      state.loader = false;
      // console.log("payload", payload);
      state.userInfo = payload.userInfo;
    },
    [update_currency.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },

    [get_support_info.fulfilled]: (state, { payload }) => {
      state.supportInfo = payload.supportInfo;
    },
    [update_support_info.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
      state.supportInfo = payload.supportInfo;
    },
    [support_logo_upload.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
      state.supportInfo = payload.supportInfo;
    },
    [changePassword.pending]: (state, _) => {
      state.loader = true;
    },
    [changePassword.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },
    [changePassword.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Password change failed';
    },
    [updateVoucherNumber.pending]: (state, _) => {
      state.loader = true;
    },
    [updateVoucherNumber.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.userInfo = payload.userInfo;
    },
    [updateVoucherNumber.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Voucher number update failed';
    },
    [updatePosConfig.pending]: (state, _) => {
      state.loader = true;
    },
    [updatePosConfig.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      if (state.userInfo?.role === 'employee') {
        state.userInfo = { ...state.userInfo, sellerId: payload.userInfo };
      } else {
        state.userInfo = payload.userInfo;
      }
    },
    [updatePosConfig.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'POS configuration update failed';
    },
    [updateStockVisibility.pending]: (state, _) => {
      state.loader = true;
    },
    [updateStockVisibility.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      // Update the userInfo with the new showStockQuantity value
      if (state.userInfo) {
        state.userInfo.showStockQuantity = payload.showStockQuantity;
      }
    },
    [updateStockVisibility.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error || 'Stock visibility update failed';
    },
    [logout.pending]: (state, _) => {
      state.loader = true;
    },
    [logout.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.token = null;
      state.role = "";
      state.userInfo = "";
    },
    [logout.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload?.error;
    },
  },
});

export const { messageClear, clearAuth } = authReducer.actions;
export default authReducer.reducer;
